import { ApolloLink } from 'apollo-link';
import ApolloClient from 'apollo-client';
import { onError } from 'apollo-link-error';
import { HttpLink } from 'apollo-link-http';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { config } from './config';

class SetHeaders extends ApolloLink {
    request(operation, forward) {
        return forward(operation);
    }
}

const cache = new InMemoryCache();
cache.writeData({
    data: {
        user: null,
        isLoggedIn: false,
        publicAppListingSearchTerm: '',
        showError: false,
        errorMessage: '',
    },
});

const userJson = localStorage.getItem('user');
if (userJson !== null && userJson !== undefined && userJson !== '') {
    cache.writeData({
        data: {
            user: JSON.parse(userJson),
            isLoggedIn: true,
        },
    });
}

export const client = new ApolloClient({
    link: ApolloLink.from([
        onError(({ graphQLErrors, networkError }) => {
            let message = '';
            if (graphQLErrors) {
                for (const err of graphQLErrors) {
                    message = message + (err.message + '. ');
                    if (err.extensions.classification === 'UnauthorizedError') {
                        localStorage.removeItem('user');
                        client.writeData({ data: { isLoggedIn: false, user: null } });
                        break;
                    }
                }
            } else if (networkError) {
                message = networkError.message;
            }
            client.writeData({ data: { showError: true, errorMessage: message } });
        }),
        new SetHeaders(),
        new HttpLink({ uri: `${config.baseUrl}/appstore/graphql`, credentials: 'include' }),
    ]),
    cache: cache,
    resolvers: {
        User: {
            showError: () => false,
        },
    },
});
